import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShopTwoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shop_two"}/>
}
